module.exports = __webpack_public_path__ + "img/img-62.464b6af9.png";